import { faqs } from '@/mocks/gossip';

export default function FaqBlock() {
  return (
    <div className="mx-auto max-w-3xl space-y-3">
      {faqs.map((f) => (
        <details
          key={f.q}
          className="group rounded-xl border border-background-200 bg-background-50 px-5 py-4 open:border-primary-200"
        >
          <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-left">
            <h3 className="font-heading text-base font-bold text-foreground-900 md:text-lg">{f.q}</h3>
            <span className="grid h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-transform group-open:rotate-45">
              <i className="ri-add-line"></i>
            </span>
          </summary>
          <p className="mt-3 border-t border-background-200 pt-3 text-sm leading-7 text-foreground-600">{f.a}</p>
        </details>
      ))}
    </div>
  );
}